export enum DisplayTransactionType {
  ATM = 'ATM',
  Card = 'Card',
  DirectDebit = 'DirectDebit',
  TransferIn = 'TransferIn',
  TransferOut = 'TransferOut',
  Unknown = 'Unknown',
  WalletTransfer = 'WalletTransfer',
}
